import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PayrollExportRoute } from './payroll-export.route';
import { UIRouterModule } from '@uirouter/angular';
import { PayrollExportContainerComponent } from './payroll-export-container';
import { PayrollExportPresenter } from './payroll-export-presenter';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        UIRouterModule.forChild({
            states: [PayrollExportRoute]
        })
    ],
})
export class PayrollExportModule {}
